import { get } from './request'

// 根据标题请求文章
const getTitle = get('/searchjson.html')

//请求专题
const getProject = get('/Index/topic_json')

export {
    getTitle,
    getProject
}